export const MOCK_REQUESTS = {
  results: [
    {
      _id: '22648a46-2a46-4e53-9da0-b68491ec5874',
      _title: 'OR-105',
      _org: '16246022',
      _tags: ['Commodity', 'Strom', 'copy'],
      _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
      _created_at: '2025-04-09T06:56:01.306Z',
      _updated_at: '2025-05-07T09:54:59.679Z',
      _schema: 'order',
      status: 'complete',
      order_number: 'OR-105',
      delivery_address: [
        {
          country: 'DE',
          city: 'Köln',
          _tags: ['delivery'],
          additional_info: '1. OG rechts',
          street: 'Adolf-Fischer-Str.',
          street_number: '2',
          _id: 'OiL64QQtspueTfBjwVkap',
          postal_code: '50670'
        }
      ],
      billing_contact: {
        $relation: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _tags: ['customer']
          }
        ]
      },
      workflow: []
    },
    {
      _id: 'bc6609ed-6b0c-4ad3-b6d4-42e72b68521f',
      _title: 'OP-102 - Wärmepumpe Teil 1 (Leadgenerierung)',
      _org: '16246022',
      _tags: ['Wärmepumpe'],
      _purpose: ['70df3680-aee0-4cc0-89b3-0df016a23efd'],
      _created_at: '2025-04-07T07:23:15.620Z',
      _updated_at: '2025-04-07T07:23:20.830Z',
      _schema: 'opportunity',
      opportunity_title: 'Wärmepumpe Teil 1 (Leadgenerierung)',
      opportunity_number: 'OP-102',
      delivery_address: {
        $relation_ref: [
          {
            _tags: [],
            path: 'address',
            _id: 'FQMknAReKWEmcTpj3Sr1V',
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
          }
        ]
      },
      customer: {
        $relation: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _tags: ['customer']
          }
        ]
      },
      workflow: [
        {
          version: 2,
          trigger: 'AUTOMATIC',
          lastUpdateTime: '2025-04-07T07:23:20.367Z',
          creationTime: '2025-04-07T07:23:20.367Z',
          assignedTo: [],
          status: 'STARTED',
          wfExecId: 'e5cjfdhsgh2',
          updateEntityAttributes: [],
          selectedClosingReasons: [],
          enableECPWorkflow: true,
          nextOpenStep: {
            entityRefId: 't5183zn3p8i',
            id: 't5183zn3p8i'
          },
          name: 'Wärmepumpe-Anlage B2C',
          taxonomies: [],
          flow: [
            {
              name: 'Prüfungsphase',
              id: 'v3xivbc3ans',
              type: 'SECTION',
              steps: [
                {
                  requirements: [],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'v3xivbc3ans',
                  type: 'STEP',
                  entityRefId: 't5183zn3p8i',
                  assignedTo: [],
                  enabled: true,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Prüfung der Daten auf Richtigkeit und Plausibilität',
                  id: 't5183zn3p8i',
                  definitionId: 'zzBis4GA',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: 'v3xivbc3ans',
                  type: 'STEP',
                  entityRefId: '7u2fgxptehl',
                  automationConfig: {
                    flowId: 'e04f1500-a9a4-482e-a632-e9fd48508a97'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  dynamicDueDate: {
                    stepId: 'zzBis4GA',
                    timePeriod: 'days',
                    numberOfUnits: 5,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Nachqualifizierungsjourney spätestens nach 5 Arbeitstagen von Interessent:in nicht ausgefüllt: Reminder E-Mail durch Automatisierung versenden. Wenn Nachqualifizierung ausgefüllt, Schritt überspringen.',
                  id: '7u2fgxptehl',
                  definitionId: '77dTm7SH',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    enabled: false
                  },
                  sectionId: 'v3xivbc3ans',
                  type: 'STEP',
                  entityRefId: 'npgiehpbtng',
                  automationConfig: {
                    flowId: 'b87be998-49a7-434d-8b43-229b6986b842'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  dynamicDueDate: {
                    stepId: '77dTm7SH',
                    timePeriod: 'days',
                    numberOfUnits: 14,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Wenn Reminder rausgeschickt wurde: Warten auf Rückmeldung von Interessent:in. Wenn zum Fälligkeitsdatum weiterhin keine Nachqualifzierung erfolgt ist, Automatisierungsschritt ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn Nachqualifizierung ausgefüllt, Schritt überspringen.',
                  id: 'npgiehpbtng',
                  definitionId: 'AXUHZhEZ',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'v3xivbc3ans',
                  type: 'STEP',
                  entityRefId: 'd84n4uyr5e7',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    description:
                      'Wir haben Ihre Anfrage erhalten und prüfen sie gerade.',
                    enabled: true,
                    label: 'Prüfungsphase'
                  },
                  userIds: [],
                  name: 'Daten der Nachqualifzierung auf Richtigkeit und Plausibilität prüfen',
                  id: 'd84n4uyr5e7',
                  definitionId: 'R1ZBPAOU',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '7tPWZ0un',
              status: 'IN_PROGRESS',
              enabled: true
            },
            {
              name: 'Qualifizierungsphase / Vor-Ort-Termin',
              id: 'b6858f58okr',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: 'b6858f58okr',
                  type: 'STEP',
                  entityRefId: 't3f047mzdyv',
                  automationConfig: {
                    flowId: '95dfed9a-b49f-418d-b711-a2fffc6883e2'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung nicht erfolgreich - Automatisierung ausführen, um Interessent:in zwecks Rückruf zu kontaktieren. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
                  id: 't3f047mzdyv',
                  definitionId: 'yN5f0rIA',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Nach dem dritten Kontaktversuch: Frist auf +30 Tage (T+30) setzen. Wenn innerhalb dieser Frist keine Rückmeldung durch Interessent:in Automatisierung ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn innerhalb der Frist eine Kontaktaufnahme erfolgt ist, Schritt überspringen.',
                    enabled: true
                  },
                  sectionId: 'b6858f58okr',
                  type: 'STEP',
                  entityRefId: 'erha3zazy9s',
                  automationConfig: {
                    flowId: 'b87be998-49a7-434d-8b43-229b6986b842'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  dynamicDueDate: {
                    stepId: 'yN5f0rIA',
                    timePeriod: 'days',
                    numberOfUnits: 1,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Weitere Kontaktaufnahme. Falls Interessent:in wieder nicht erreicht, Aufgabe offen lassen, Frist auf +1 Tag setzen und Automatisierung aus vorherigem Schritt erneut ausführen. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
                  id: 'erha3zazy9s',
                  definitionId: 'EeCC5puB',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                    enabled: true
                  },
                  sectionId: 'b6858f58okr',
                  type: 'STEP',
                  entityRefId: 'nblwq5qvudm',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung - Datum in Feld "1. Vor-Ort-Termin" eintragen.',
                  id: 'nblwq5qvudm',
                  definitionId: '_Y9T46UT',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  journey: {
                    journeyId: 'c1deff70-1123-11f0-81ce-455e80ecdcf1',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: '81148d18-84af-4d70-8889-3675bb2207ce'
                  },
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Fotos aus dem Vor-Ort-Termin der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".\n                                \nUploadkategorien:\n- Gebäudegrundriss\n- Heizungsraum\n- Heizkörper\n- Aktuelle Heizungsanlage (falls nicht schon eingereicht)\n- Aufstellort innen\n- Standort der Außeneinheit\n- Verbrauchswerte / Stromrechnungen der letzten 3 Jahre (falls nicht schon eingereicht)\n- Zählerschrank\n- Sonstiges\n',
                    enabled: true
                  },
                  sectionId: 'b6858f58okr',
                  type: 'STEP',
                  entityRefId: 'hbfpbq583a6',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    description:
                      'Für die weitere Planung ist es notwendig das Objekt vor Ort zu besichtigen.',
                    enabled: true,
                    label: 'Vor-Ort-Terminierung'
                  },
                  userIds: [],
                  name: 'Während des Vor-Ort-Termins: Fehlende Fotos/ Informationen einholen - Fotos über verknüpfte Klickstrecke hochladen.',
                  id: 'hbfpbq583a6',
                  definitionId: 'xMh0jYAR',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'b6858f58okr',
                  type: 'STEP',
                  entityRefId: 'xgvxd5in3j6',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Opportunity und alle relevanten Entitäten über das Teilen Symbol (oben rechts) mit dem Partner teilen.',
                  id: 'xgvxd5in3j6',
                  definitionId: 'JMDHcRzK',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'j7eJh3wY',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Prüfungsphase Partner',
              id: 'z1ylaxlx6pa',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                    enabled: true
                  },
                  sectionId: 'z1ylaxlx6pa',
                  type: 'STEP',
                  entityRefId: '1tti24416ni',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Partner: optionale 2. Vor-Ort-Terminvereinbarung - Datum in Feld "2. Vor-Ort-Termin" eintragen.',
                  id: '1tti24416ni',
                  definitionId: 'c36_ZWe9',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  journey: {
                    journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                    name: 'Allgemein - Uploads Partner',
                    id: 'd9d2d361-e541-4121-bae3-881defee193b'
                  },
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie den Kostenvoranschlag übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'z1ylaxlx6pa',
                  type: 'STEP',
                  entityRefId: 'g3i55tad2u8',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Partner: KVA Erstellung - KVA über verknüpfte Klickstrecke hochladen.',
                  id: 'g3i55tad2u8',
                  definitionId: 'j_KdVk98',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '-hj_-Fi3',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'KVA Erstellung inkl. Versand an Interessent:in',
              id: 'lfj21h4scib',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'lfj21h4scib',
                  type: 'STEP',
                  entityRefId: 'mh7pfrwe5eo',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Handwerker-KVA überprüfen und auf Basis des KVA eine Bestellung unter Gruppe "Bestellungen und Angebote" anlegen und speichern.',
                  id: 'mh7pfrwe5eo',
                  definitionId: 'I_2MFpk_',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Sobald der KVA an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Attribut zu übertragen.',
                    enabled: true
                  },
                  sectionId: 'lfj21h4scib',
                  type: 'STEP',
                  entityRefId: '095caos385l',
                  automationConfig: {
                    flowId: 'a5d16486-b1ef-4766-a1c0-a920c9c45da9'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'E-Mail-Vorlage "Wärmepumpe - KVA inkl. Annahme" auswählen, erstellten KVA prüfen und E-Mail versenden.',
                  id: '095caos385l',
                  definitionId: '8fjgsHao',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: 'lfj21h4scib',
                  type: 'STEP',
                  entityRefId: 'h34bul6ah2d',
                  automationConfig: {
                    flowId: '6a46a2c2-ba14-481e-a7d3-1da4f5a4a5ca'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  dynamicDueDate: {
                    stepId: '8fjgsHao',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'KVA Annahme erfolgt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Falls KVA Annahme bereits erfolgt, Schritt überspringen.',
                  id: 'h34bul6ah2d',
                  definitionId: 'xoFHz1FG',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'kAdQ_g3h',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Angebotsphase',
              id: '1o9vqvh2avn',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  journey: {
                    journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                    name: 'Allgemein - Uploads Partner',
                    id: 'd9d2d361-e541-4121-bae3-881defee193b'
                  },
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Heizlastberechnung sowie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: '1o9vqvh2avn',
                  type: 'STEP',
                  entityRefId: 'hcwmliabkjh',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Heizlastberechnung durchführen und Erstellung Angebot - beide Dokumente über verknüpfte Klickstrecke hochladen.',
                  id: 'hcwmliabkjh',
                  definitionId: '8uHdvwLd',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Der ursprüngliche KVA wird ebenfalls als finales Angebot verwendet. Entsprechend müssen etwaige Anpassungen im ursprünglichen KVA vorgenommen werden.',
                    enabled: true
                  },
                  sectionId: '1o9vqvh2avn',
                  type: 'STEP',
                  entityRefId: 'zphajyec9xn',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Handwerker-Angebot überprüfen und bestehenden KVA unter Gruppe "Bestellungen und Angebote", wenn benötigt, anpassen und speichern.',
                  id: 'zphajyec9xn',
                  definitionId: 'p3Pgs00f',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Sobald das finale Angebot an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Attribut zu übertragen.',
                    enabled: true
                  },
                  sectionId: '1o9vqvh2avn',
                  type: 'STEP',
                  entityRefId: '0m6ydqtuvcy',
                  automationConfig: {
                    flowId: 'e39e9229-ec50-4715-9f19-f479ab2c64ac'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    description:
                      'Wir planen aktuell Ihre individuelle Heizungsanlage.',
                    enabled: true,
                    label: 'Planung der Heizungsanlage'
                  },
                  userIds: [],
                  name: 'Email-Vorlage "Wärmepumpe - Finales Angebot inkl. Angebotsannahme" auswählen, erstelltes Angebot prüfen und E-Mail versenden.',
                  id: '0m6ydqtuvcy',
                  definitionId: 'OfHwI_qm',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: '1o9vqvh2avn',
                  type: 'STEP',
                  entityRefId: '21z53hls2on',
                  automationConfig: {
                    flowId: '0b72ca00-06a1-4b64-8406-0484fa841185'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: false
                  },
                  dynamicDueDate: {
                    stepId: 'OfHwI_qm',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Angebotsannahme erfolgt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Wenn "Ja", Schritt überspringen.',
                  id: '21z53hls2on',
                  definitionId: 'f-kS2-D5',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: '1o9vqvh2avn',
                  type: 'STEP',
                  entityRefId: 'teqqqcz7mf0',
                  automationConfig: {
                    flowId: 'b87be998-49a7-434d-8b43-229b6986b842'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    description:
                      'Sind Sie mit dem unterbreiteten Angebot zufrieden?',
                    enabled: true,
                    label: 'Angebotsphase'
                  },
                  dynamicDueDate: {
                    stepId: 'f-kS2-D5',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Angebotsannahme erfolgt? Wenn "Nein", Automatisierungsschritt ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn "Ja", Schritt überspringen.',
                  id: 'teqqqcz7mf0',
                  definitionId: 'BCtBCqmL',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'nkelpCQ7',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Förderung - diese Phase ist nur relevant, wenn Kund:in eine Förderung plant',
              id: '8vrmkrnywue',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: '8vrmkrnywue',
                  type: 'STEP',
                  entityRefId: 'cqieaingxfv',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Wenn Planung Förderung "Ja", dann Partner die nächste Aufgabe zuweisen. Wenn Planung Förderung "Nein", dann Schritt überspringen.',
                  id: 'cqieaingxfv',
                  definitionId: 'XGxUmxcY',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Beauftragung unter Vorbehalt der Förderzusage: \nKund:in hat das Angebot angenommen und möchte eine Förderung beantragen. Damit der Liefer- und Leistungsvertrag für die Beantragung der Fördermittel erstellt werden kann, benötigen wir noch die BzA-Nummer sowie eine kurze Beschreibung des geplanten Sanierungsvorhabens. Bitte übermitteln Sie uns diese Angaben zeitnah.\n',
                    enabled: true
                  },
                  sectionId: '8vrmkrnywue',
                  type: 'STEP',
                  entityRefId: '1obk6fyrftb',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: BzA (Bestätigung zum Antrag) in Feld "BzA Nummer" eintragen und Sanierungsvorhaben in Feld "Beschreibung Sanierungsvorhaben" kurz beschreiben. Wenn Planung Förderung "Nein", dann Schritt überspringen.',
                  id: '1obk6fyrftb',
                  definitionId: '4_jGYwMO',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Sobald der LL an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Attribut zu übertragen.',
                    enabled: true
                  },
                  sectionId: '8vrmkrnywue',
                  type: 'STEP',
                  entityRefId: 'usupybesp7z',
                  automationConfig: {
                    flowId: 'a3047916-3c81-4a71-adfa-7652eaf27913'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Wenn Planung Förderung "Ja": Email-Vorlage "Wärmepumpe - Übermittlung Liefer- und Leistungsvertrag" (LL) auswählen, erstellten LL prüfen und E-Mail versenden. Wenn Planung Förderung "Nein", dann Schritt überspringen.',
                  id: 'usupybesp7z',
                  definitionId: 'kMlllOkG',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: '8vrmkrnywue',
                  type: 'STEP',
                  entityRefId: 'rk07hz7nr44',
                  automationConfig: {
                    flowId: '2d5666ae-4d6d-43fc-9171-9108fae4b5d9'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  dynamicDueDate: {
                    stepId: 'kMlllOkG',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Wenn Planung Förderung "Ja": Hat Interessent:in signierten LL übermittelt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Falls unterschriebener LL vorliegt bzw. Planung Förderung "Nein", Schritt überspringen.',
                  id: 'rk07hz7nr44',
                  definitionId: 'dpaVvdSQ',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: '8vrmkrnywue',
                  type: 'STEP',
                  entityRefId: 'nkgb7zf0wlx',
                  automationConfig: {
                    flowId: '30805cb3-cd38-4889-a490-ab41d1f0f500'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  dynamicDueDate: {
                    stepId: 'dpaVvdSQ',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Wenn Planung Förderung "Ja": Hat Interessent:in Status zum Fördermittelantrag übermittelt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Falls Status Fördermittelbescheid vorliegt bzw. Planung Förderung "Nein", Schritt überspringen.',
                  id: 'nkgb7zf0wlx',
                  definitionId: 'OelIMKoT',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Sobald das finale Angebot an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Attribut zu übertragen (Dabei wird die aktuelle Übermittlung des ursprünglichen ungültigen Angebots überschrieben).',
                    enabled: true
                  },
                  sectionId: '8vrmkrnywue',
                  type: 'STEP',
                  entityRefId: 'cln3wrnu6qg',
                  automationConfig: {
                    flowId: 'e39e9229-ec50-4715-9f19-f479ab2c64ac'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  dynamicDueDate: {
                    stepId: 'OelIMKoT',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Wenn Planung Förderung "Ja": Sichtung Fördermittelbescheid: Wenn Fördermittelbescheid "Genehmigt", dann Schritt überspringen. Wenn Fördermittelbescheid "Nicht genehmigt" Kontaktaufnahme mit Interessent:in, um weitere Vorgehensweise zu besprechen. Wenn Interessent:in weiterhin Interesse hat, E-Mail-Vorlage "Finales Angebot inkl. Angebotsannahme (bei negativem Förderbescheid)" auswählen, erstelltes Angebot prüfen und E-Mail versenden. Wenn kein Interesse, Prozess abbrechen. Wenn Planung Förderung "Nein", Schritt überspringen.',
                  id: 'cln3wrnu6qg',
                  definitionId: 'dlEHgQZS',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: '8vrmkrnywue',
                  type: 'STEP',
                  entityRefId: '92avp2lrdi8',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    description:
                      'Für die weitere Bearbeitung benötigen wir Details zur Förderung.',
                    enabled: true,
                    label: 'Details zur Förderung'
                  },
                  dynamicDueDate: {
                    stepId: 'dlEHgQZS',
                    timePeriod: 'days',
                    numberOfUnits: 14,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Falls 2. Angebotsannahme erfolgt, Schritt überspringen. Falls 2. Angebotsannahme nicht erfolgt, Prozess abbrechen.',
                  id: '92avp2lrdi8',
                  definitionId: '_FaR6eV3',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'Sfl3AtnQ',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Vorbereitung Bereitstellung',
              id: '9ax62mizqzn',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_FaR6eV3'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  journey: {
                    journeyId: 'c1deff70-1123-11f0-81ce-455e80ecdcf1',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: '81148d18-84af-4d70-8889-3675bb2207ce'
                  },
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die 1. Anzahlungsrechnung übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                    enabled: true
                  },
                  sectionId: '9ax62mizqzn',
                  type: 'STEP',
                  entityRefId: '2yufdo3tqop',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'ERP: 1. Anzahlungsrechnung erstellen: Rechnungsversand an Kund:in (1. Rechnung - Anzahlung) - Anzahlungsrechnung über verknüpfte Klickstrecke hochladen.',
                  id: '2yufdo3tqop',
                  definitionId: 'dd7i4fmj',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_FaR6eV3'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Mit der Ausführung der Automatisierung wird das Datum der Beauftragung des Partners in das entsprechende Feld übertragen. Die Beauftragung des Partners ist in den weiteren informationen im nächsten Schritt vermerkt.',
                    enabled: true
                  },
                  sectionId: '9ax62mizqzn',
                  type: 'STEP',
                  entityRefId: '3ibcrapnyjl',
                  automationConfig: {
                    flowId: '997ec8f3-aa6e-4879-aa83-ae6f443b2c35'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: false
                  },
                  dynamicDueDate: {
                    stepId: 'dd7i4fmj',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Wiedervorlage: Zahlung eingegangen? Wenn "Ja", Automatisierungsschritt ausführen - Beauftragung des Partners über nachfolgende Aufgabe. Wenn "Nein", Kontaktaufnahme mit Kund:in und neue Frist auf T+7 setzen.',
                  id: '3ibcrapnyjl',
                  definitionId: 'G8Y9cTif',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '65Dt7ZS9',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Installation inkl. Fertigstellung Partner',
              id: '133sfkbeyjh',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_FaR6eV3'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Finale Beauftragung für Installation der Wärmepumpe: \nKund:in hat das Angebot angenommen. Für die Terminvereinbarung zur Installation, sowie die weitere interne Organisation bitte die Widerrufsfrist beachten (siehe Feld Ende Widerrufsfrist)!\n',
                    enabled: true
                  },
                  sectionId: '133sfkbeyjh',
                  type: 'STEP',
                  entityRefId: 'em6rc9yw73x',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Terminvereinbarung und Baubeginn (nach Widerrufsfrist) - Datum Baubeginn in Feld "Baubeginn" eintragen.',
                  id: 'em6rc9yw73x',
                  definitionId: 'bTVIdKd5',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_FaR6eV3'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: '133sfkbeyjh',
                  type: 'STEP',
                  entityRefId: 'ewxj9pvuafn',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Wärmepumpe wurde beim Netzbetreiber angemeldet, sowie ggf. erforderlicher Zähler.',
                  id: 'ewxj9pvuafn',
                  definitionId: 'g3eVTm5t',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_FaR6eV3'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  journey: {
                    journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                    name: 'Allgemein - Uploads Partner',
                    id: 'd9d2d361-e541-4121-bae3-881defee193b'
                  },
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Abnahmeprotokoll der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: '133sfkbeyjh',
                  type: 'STEP',
                  entityRefId: '3vwopy708q7',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Partner: Baumaßnahmen wurden fertiggestellt und abgenommen - Datum der Fertigstellung in Feld "Fertigstellung" eintragen - Abnahmeprotokoll über verknüpfte Klickstrecke hochladen.',
                  id: '3vwopy708q7',
                  definitionId: 'fsSeQWuu',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_FaR6eV3'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'fsSeQWuu'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  journey: {
                    journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                    name: 'Allgemein - Uploads Partner',
                    id: 'd9d2d361-e541-4121-bae3-881defee193b'
                  },
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Obligatorisch für den Fall, dass der Kund:in die Förderung gewährt wurde.\nIn diesem Schritt ist eine Klickstrecke integriert, in der Sie die Bestätigung der Durchführung (BnD) der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".\n',
                    enabled: true
                  },
                  sectionId: '133sfkbeyjh',
                  type: 'STEP',
                  entityRefId: '5tngmzk5ksd',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  userIds: [],
                  name: 'Partner: Bestätigung nach Durchführung (BnD) wurde Kund:in ausgestellt.',
                  id: '5tngmzk5ksd',
                  definitionId: 'An4yz9pM',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_FaR6eV3'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'fsSeQWuu'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  journey: {
                    journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                    name: 'Allgemein - Uploads Partner',
                    id: 'd9d2d361-e541-4121-bae3-881defee193b'
                  },
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Dokumentation der Errichtung und der Inbetriebnahme der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: '133sfkbeyjh',
                  type: 'STEP',
                  entityRefId: 'w9rgqj2q86c',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: true,
                    label: 'Installation inkl. Fertigstellung'
                  },
                  userIds: [],
                  name: 'Partner: Dokumentation der Errichtung und der Inbetriebnahme - Dokumente über verknüpfte Klickstrecke hochladen.',
                  id: 'w9rgqj2q86c',
                  definitionId: 'MyqzJdfC',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_FaR6eV3'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'fsSeQWuu'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'MyqzJdfC'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  journey: {
                    journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                    name: 'Allgemein - Uploads Partner',
                    id: 'd9d2d361-e541-4121-bae3-881defee193b'
                  },
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: '133sfkbeyjh',
                  type: 'STEP',
                  entityRefId: 'youefa1pcux',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Schlussrechnung erstellen - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
                  id: 'youefa1pcux',
                  definitionId: 'PnKp6bGK',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'OgeUHFyc',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Abschluss',
              id: 'jkxsyxkletj',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '77dTm7SH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'AXUHZhEZ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'R1ZBPAOU'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'JMDHcRzK'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'j_KdVk98'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'I_2MFpk_'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8fjgsHao'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xoFHz1FG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '8uHdvwLd'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'f-kS2-D5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'BCtBCqmL'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'XGxUmxcY'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '4_jGYwMO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'kMlllOkG'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dpaVvdSQ'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OelIMKoT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dlEHgQZS'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_FaR6eV3'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'fsSeQWuu'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'MyqzJdfC'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'PnKp6bGK'
                    }
                  ],
                  startedTime: '2025-04-07T07:23:20.367Z',
                  journey: {
                    journeyId: 'c1deff70-1123-11f0-81ce-455e80ecdcf1',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: '81148d18-84af-4d70-8889-3675bb2207ce'
                  },
                  created: '2025-04-07T07:23:20.367Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                    enabled: true
                  },
                  sectionId: 'jkxsyxkletj',
                  type: 'STEP',
                  entityRefId: 'b1mwlvpsmzc',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:23:20.367Z',
                  ecp: {
                    enabled: true,
                    label: 'Abschluss'
                  },
                  userIds: [],
                  name: 'ERP: Schlussrechnung an Kund:in senden - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
                  id: 'b1mwlvpsmzc',
                  definitionId: '76QWWDEa',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '8vvcDG0J',
              status: 'OPEN',
              enabled: true
            }
          ],
          configuredClosingReasonSnapshot: [
            {
              title: 'Wirtschaftlichkeit',
              id: '4vDdM4Ta5TIiK2ZLQFv2M'
            },
            {
              title: 'Entscheidung für Mitbewerber',
              id: 'uUW4-bIsq5Ozm3xcmIRC8'
            },
            {
              title: 'Zeitlich nicht passend',
              id: 'ZdbD_S25HvYBZfOSX4Z1e'
            },
            {
              title: 'Keine Angabe von Gründen',
              id: 'nH_sgr1zfOtV13maXhScO'
            },
            {
              title: 'Kein Interesse nach negativem Fördermittelbescheid',
              id: '0klnIumPiUKeLXWoRU0D_'
            },
            {
              title: 'Keine Rückmeldung vom Kunden',
              id: '08xZ-Ex6VxT6fD_tZO-5E'
            },
            {
              title: 'Zu lange Wartezeit',
              id: 'lm9Rp2kd8i94PfJpnQi7-'
            },
            {
              title: 'Kosten zu hoch',
              id: 'eq8g6NXYOmqkWdh2EvieE'
            }
          ],
          contexts: [
            {
              schema: 'contact',
              title: 'Max Spark',
              id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
            },
            {
              schema: 'opportunity',
              title: 'OP-102 - Wärmepumpe Teil 1 (Leadgenerierung)',
              id: 'bc6609ed-6b0c-4ad3-b6d4-42e72b68521f'
            }
          ],
          orgId: '16246022',
          definitionId: 'wfiHJi3ZfB',
          id: 'e5cjfdhsgh2'
        }
      ]
    },
    {
      _id: '29acac9c-b91f-44c0-be37-349fdf5957ed',
      _title: 'OP-101 - Photovoltaik-Anlage Teil 1 (Leadgenerierung)',
      _org: '16246022',
      _tags: ['PV'],
      _purpose: ['f9644d19-d842-4f84-b0e0-974e7fa3bf13'],
      _created_at: '2025-04-07T07:21:07.202Z',
      _updated_at: '2025-04-07T07:21:11.948Z',
      _schema: 'opportunity',
      opportunity_title: 'Photovoltaik-Anlage Teil 1 (Leadgenerierung)',
      opportunity_number: 'OP-101',
      delivery_address: {
        $relation_ref: [
          {
            _tags: [],
            path: 'address',
            _id: 'FQMknAReKWEmcTpj3Sr1V',
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
          }
        ]
      },
      customer: {
        $relation: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _tags: ['customer']
          }
        ]
      },
      workflow: [
        {
          version: 2,
          trigger: 'AUTOMATIC',
          lastUpdateTime: '2025-04-07T07:21:11.571Z',
          creationTime: '2025-04-07T07:21:11.571Z',
          assignedTo: [],
          status: 'STARTED',
          wfExecId: 'lf9mry8md2j',
          updateEntityAttributes: [],
          selectedClosingReasons: [],
          enableECPWorkflow: true,
          nextOpenStep: {
            entityRefId: 'eut4k21cz1n',
            id: 'eut4k21cz1n'
          },
          name: 'Photovoltaik-Anlage B2C',
          taxonomies: [],
          flow: [
            {
              name: 'Prüfungsphase',
              id: '60htsvmnx5k',
              type: 'SECTION',
              steps: [
                {
                  requirements: [],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: '60htsvmnx5k',
                  type: 'STEP',
                  entityRefId: 'eut4k21cz1n',
                  assignedTo: [],
                  enabled: true,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    description:
                      'Wir haben Ihre Anfrage erhalten und prüfen sie gerade.',
                    enabled: true,
                    label: 'Prüfungsphase'
                  },
                  userIds: [],
                  name: 'Prüfung der Daten auf Richtigkeit und Plausibilität',
                  id: 'eut4k21cz1n',
                  definitionId: 'zzBis4GA',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '7tPWZ0un',
              status: 'IN_PROGRESS',
              enabled: true
            },
            {
              name: 'Qualifizierungsphase / Vor-Ort-Termin',
              id: 'yjnmiskj647',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: 'yjnmiskj647',
                  type: 'STEP',
                  entityRefId: 'vn9e4qdoysz',
                  automationConfig: {
                    flowId: 'ae123b8e-7032-49aa-9785-67fd1785a56b'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  userIds: [],
                  name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung nicht erfolgreich - Automatisierung ausführen, um Interessent:in zwecks Rückruf zu kontaktieren. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
                  id: 'vn9e4qdoysz',
                  definitionId: 'yN5f0rIA',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Nach dem dritten Kontaktversuch: Frist auf +30 Tage setzen. Wenn innerhalb dieser Frist keine Rückmeldung durch Interessent:in Automatisierung ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn innerhalb der Frist eine Kontaktaufnahme erfolgt ist, Schritt überspringen.',
                    enabled: true
                  },
                  sectionId: 'yjnmiskj647',
                  type: 'STEP',
                  entityRefId: 'nop2varlmle',
                  automationConfig: {
                    flowId: '497dbc84-9c70-42e6-8aba-e85103ca9ba2'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  dynamicDueDate: {
                    stepId: 'yN5f0rIA',
                    timePeriod: 'days',
                    numberOfUnits: 1,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Weitere Kontaktaufnahme. Falls Interessent:in wieder nicht erreicht, Aufgabe offen lassen, Frist auf +1 Tag setzen und Automatisierung aus vorherigem Schritt erneut ausführen. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
                  id: 'nop2varlmle',
                  definitionId: 'EeCC5puB',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                    enabled: true
                  },
                  sectionId: 'yjnmiskj647',
                  type: 'STEP',
                  entityRefId: 'v9wulf0ryw4',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  userIds: [],
                  name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung - Datum in Feld "1. Vor-Ort-Termin" eintragen.',
                  id: 'v9wulf0ryw4',
                  definitionId: '_Y9T46UT',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  journey: {
                    journeyId: '077da6b0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Photovoltaik-Anlage Teil 2 (Nachqualifizierung Vor-Ort-Termin)',
                    id: '5d915b93-5487-467d-83ce-a9d89dde5b4d'
                  },
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die zusätzlichen Informationen und Fotos aus dem Vor-Ort-Termin der Opportunity hinzufügen können. Klicken Sie dafür auf "Photovoltaik-Anlage Teil 2 (Nachqualifizierung Vor-Ort-Termin)".',
                    enabled: true
                  },
                  sectionId: 'yjnmiskj647',
                  type: 'STEP',
                  entityRefId: 'p2alcysdjb8',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    description:
                      'Für die weitere Planung ist es notwendig das Objekt vor Ort zu besichtigen.',
                    enabled: true,
                    label: 'Vor-Ort-Terminierung'
                  },
                  userIds: [],
                  name: 'Während des Vor-Ort-Termins: Zusätzliche Informationen und Fotos einholen - Daten über verknüpfte Klickstrecke hochladen.',
                  id: 'p2alcysdjb8',
                  definitionId: 'xMh0jYAR',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  journey: {
                    journeyId: '0240b570-1126-11f0-8e95-4d06e2df98e6',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: 'f61cd947-c717-4aaa-a424-6f0a2e91e322'
                  },
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".\n                                \nUploadkategorien:\n- Gebäudegrundriss\n- Zählerschrank\n- Zähler mit Zählernummer\n- möglicher Standort Wechselrichter/ Batteriespeicher\n- Dach\n- mögliche Verschattungen\n- Sonstiges\n',
                    enabled: true
                  },
                  sectionId: 'yjnmiskj647',
                  type: 'STEP',
                  entityRefId: '0uj9t9mh8yx',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Dokumente/ Fotos aus Vor-Ort-Termin über verknüpfte Klickstrecke hochladen.',
                  id: '0uj9t9mh8yx',
                  definitionId: 'ZmyKvhEM',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'yjnmiskj647',
                  type: 'STEP',
                  entityRefId: 'xmidd5uy59r',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  userIds: [],
                  name: 'Opportunity und alle relevanten Entitäten über das Teilen Symbol (oben rechts) mit dem Partner teilen.',
                  id: 'xmidd5uy59r',
                  definitionId: 'RvhUavum',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'j7eJh3wY',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Prüfungsphase Partner',
              id: 'ixnk2fn1q2c',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                    enabled: true
                  },
                  sectionId: 'ixnk2fn1q2c',
                  type: 'STEP',
                  entityRefId: 'hanr4jjapb0',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  userIds: [],
                  name: 'Partner: optionale 2. Vor-Ort-Terminvereinbarung - Datum in Feld "2. Vor-Ort-Termin" eintragen. Falls nicht relevant, Schritt überspringen.',
                  id: 'hanr4jjapb0',
                  definitionId: 'c36_ZWe9',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  journey: {
                    journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Allgemein - Uploads Partner',
                    id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
                  },
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'ixnk2fn1q2c',
                  type: 'STEP',
                  entityRefId: 'sq9up84yr5s',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Erstellung Angebot - Dokument über verknüpfte Klickstrecke hochladen.',
                  id: 'sq9up84yr5s',
                  definitionId: '7v_W2vaH',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '-hj_-Fi3',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Angebotsphase',
              id: 'vfshewagar7',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'vfshewagar7',
                  type: 'STEP',
                  entityRefId: 'gmss1wj1uwh',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Handwerker-Angebot überprüfen und auf Basis des Angebots eine Bestellung unter Gruppe "Bestellungen und Angebote" anlegen und speichern.',
                  id: 'gmss1wj1uwh',
                  definitionId: 'p3Pgs00f',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Sobald das finale Angebot an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Feld zu übertragen.',
                    enabled: true
                  },
                  sectionId: 'vfshewagar7',
                  type: 'STEP',
                  entityRefId: '5n58g7v1c0b',
                  automationConfig: {
                    flowId: '5de894b0-174e-49e4-9eb5-884cb032e17c'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    description:
                      'Wir planen aktuell Ihre individuelle Photovoltaik-Anlage.',
                    enabled: true,
                    label: 'Planung der Photovoltaik-Anlage'
                  },
                  userIds: [],
                  name: 'Email-Vorlage "PV - Finales Angebot inkl. Angebotsannahme" auswählen, erstelltes Angebot prüfen und E-Mail versenden.',
                  id: '5n58g7v1c0b',
                  definitionId: 'OfHwI_qm',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: 'vfshewagar7',
                  type: 'STEP',
                  entityRefId: 'uc6n8sugt06',
                  automationConfig: {
                    flowId: 'b5c07ff3-b5a4-4f13-90c0-ad9004e63fb1'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  dynamicDueDate: {
                    stepId: 'OfHwI_qm',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Angebotsannahme erfolgt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Wenn "Ja", Schritt überspringen.',
                  id: 'uc6n8sugt06',
                  definitionId: '5h5bw2yO',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: 'vfshewagar7',
                  type: 'STEP',
                  entityRefId: 'rlyxnwqkg0p',
                  automationConfig: {
                    flowId: '497dbc84-9c70-42e6-8aba-e85103ca9ba2'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    description:
                      'Sind Sie mit dem unterbreiteten Angebot zufrieden?',
                    enabled: true,
                    label: 'Angebotsphase'
                  },
                  dynamicDueDate: {
                    stepId: '5h5bw2yO',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Angebotsannahme erfolgt? Wenn "Nein", Automatisierungsschritt ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn "Ja", Schritt überspringen.',
                  id: 'rlyxnwqkg0p',
                  definitionId: 'HMTLIkea',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'nkelpCQ7',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Vorbereitung Bereitstellung',
              id: 'ub7io1guesl',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  journey: {
                    journeyId: '0240b570-1126-11f0-8e95-4d06e2df98e6',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: 'f61cd947-c717-4aaa-a424-6f0a2e91e322'
                  },
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die 1. Anzahlungsrechnung übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                    enabled: true
                  },
                  sectionId: 'ub7io1guesl',
                  type: 'STEP',
                  entityRefId: '3gtc2xuprv8',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  userIds: [],
                  name: 'ERP: 1. Anzahlungsrechnung erstellen: Rechnungsversand an Kund:in (1. Rechnung - Anzahlung) - Anzahlungsrechnung über verknüpfte Klickstrecke hochladen.',
                  id: '3gtc2xuprv8',
                  definitionId: 'dd7i4fmj',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Mit der Ausführung der Automatisierung wird das Datum der Beauftragung des Partners in das entsprechende Feld übertragen. Die Beauftragung des Partners ist in den weiteren informationen im nächsten Schritt vermerkt.',
                    enabled: true
                  },
                  sectionId: 'ub7io1guesl',
                  type: 'STEP',
                  entityRefId: 'l39gh2bxffs',
                  automationConfig: {
                    flowId: 'f7635782-6eb9-424a-8a5b-2c73623adb27'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  dynamicDueDate: {
                    stepId: 'dd7i4fmj',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Wiedervorlage: Zahlung eingegangen? Wenn "Ja", Automatisierungsschritt ausführen - Beauftragung des Partners über nachfolgende Aufgabe. Wenn "Nein", Kontaktaufnahme mit Kund:in und neue Frist auf T+7 setzen.',
                  id: 'l39gh2bxffs',
                  definitionId: 'G8Y9cTif',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '65Dt7ZS9',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Installation inkl. Fertigstellung Partner',
              id: 'yjhbw9lr0xe',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Finale Beauftragung für Installation der Photovoltaik-Anlage: \nKund:in hat das Angebot angenommen. Für die Antragstellung beim Netzbetreiber, sowie die weitere interne Organisation bitte die Widerrufsfrist beachten (siehe Feld Ende Widerrufsfrist)!\n',
                    enabled: true
                  },
                  sectionId: 'yjhbw9lr0xe',
                  type: 'STEP',
                  entityRefId: 'dpx0wpkqa2z',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  userIds: [],
                  name: 'Partner: Antragstellung beim Netzbetreiber',
                  id: 'dpx0wpkqa2z',
                  definitionId: 'bTVIdKd5',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'yjhbw9lr0xe',
                  type: 'STEP',
                  entityRefId: 'lbweg8ufa7x',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  userIds: [],
                  name: 'Partner: Terminvereinbarung und Baubeginn (nach Widerrufsfrist) - Datum Baubeginn in Feld "Baubeginn" eintragen.',
                  id: 'lbweg8ufa7x',
                  definitionId: 'g3eVTm5t',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  journey: {
                    journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Allgemein - Uploads Partner',
                    id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
                  },
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Abnahmeprotokoll der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'yjhbw9lr0xe',
                  type: 'STEP',
                  entityRefId: 'npetsosu4vu',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  userIds: [],
                  name: 'Partner: Baumaßnahmen wurden fertiggestellt und abgenommen - Datum der Fertigstellung in Feld "Fertigstellung" eintragen - Abnahmeprotokoll über verknüpfte Klickstrecke hochladen.',
                  id: 'npetsosu4vu',
                  definitionId: 'An4yz9pM',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  journey: {
                    journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Allgemein - Uploads Partner',
                    id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
                  },
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Dokumentation der Errichtung und der Inbetriebnahme der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'yjhbw9lr0xe',
                  type: 'STEP',
                  entityRefId: 'at3pffjl3d6',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    enabled: true,
                    label: 'Installation inkl. Fertigstellung'
                  },
                  userIds: [],
                  name: 'Partner: Dokumentation der Errichtung und der Inbetriebnahme - Dokumente über verknüpfte Klickstrecke hochladen.',
                  id: 'at3pffjl3d6',
                  definitionId: 'oYLqfdHr',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'oYLqfdHr'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  journey: {
                    journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Allgemein - Uploads Partner',
                    id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
                  },
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'yjhbw9lr0xe',
                  type: 'STEP',
                  entityRefId: 'ls5xw45mf16',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Schlussrechnung erstellen - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
                  id: 'ls5xw45mf16',
                  definitionId: 'PnKp6bGK',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'OgeUHFyc',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Abschluss',
              id: '04d3sx21bfh',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'oYLqfdHr'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'PnKp6bGK'
                    }
                  ],
                  startedTime: '2025-04-07T07:21:11.571Z',
                  journey: {
                    journeyId: '0240b570-1126-11f0-8e95-4d06e2df98e6',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: 'f61cd947-c717-4aaa-a424-6f0a2e91e322'
                  },
                  created: '2025-04-07T07:21:11.571Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                    enabled: true
                  },
                  sectionId: '04d3sx21bfh',
                  type: 'STEP',
                  entityRefId: 'i0e1l0qz1fm',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:21:11.571Z',
                  ecp: {
                    enabled: true,
                    label: 'Abschluss'
                  },
                  userIds: [],
                  name: 'ERP: Schlussrechnung an Kund:in senden - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
                  id: 'i0e1l0qz1fm',
                  definitionId: '76QWWDEa',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '8vvcDG0J',
              status: 'OPEN',
              enabled: true
            }
          ],
          configuredClosingReasonSnapshot: [
            {
              title: 'Dach zu alt',
              id: 'aR7zJFjtI6Q0ZH_EXGtXc'
            },
            {
              title: 'Wirtschaftlichkeit',
              id: '4vDdM4Ta5TIiK2ZLQFv2M'
            },
            {
              title: 'Entscheidung für Mitbewerber',
              id: 'uUW4-bIsq5Ozm3xcmIRC8'
            },
            {
              title: 'Zeitlich nicht passend',
              id: 'ZdbD_S25HvYBZfOSX4Z1e'
            },
            {
              title: 'Keine Angabe von Gründen',
              id: 'nH_sgr1zfOtV13maXhScO'
            },
            {
              title: 'Keine Rückmeldung vom Kunden',
              id: '08xZ-Ex6VxT6fD_tZO-5E'
            },
            {
              title: 'Kosten zu hoch',
              id: 'eq8g6NXYOmqkWdh2EvieE'
            },
            {
              title: 'Zu lange Wartezeit',
              id: 'lm9Rp2kd8i94PfJpnQi7-'
            }
          ],
          contexts: [
            {
              schema: 'contact',
              title: 'Max Spark',
              id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
            },
            {
              schema: 'opportunity',
              title: 'OP-101 - Photovoltaik-Anlage Teil 1 (Leadgenerierung)',
              id: '29acac9c-b91f-44c0-be37-349fdf5957ed'
            }
          ],
          orgId: '16246022',
          definitionId: 'wfMXhDSGaI',
          id: 'lf9mry8md2j'
        }
      ]
    },
    {
      _id: '5623d4b1-62d1-43ce-8118-44fc453c511c',
      _title: 'OP-100 - Photovoltaik-Anlage Teil 1 (Leadgenerierung)',
      _org: '16246022',
      _tags: ['PV'],
      _purpose: ['f9644d19-d842-4f84-b0e0-974e7fa3bf13'],
      _created_at: '2025-04-07T07:19:58.684Z',
      _updated_at: '2025-05-07T11:56:51.796Z',
      _schema: 'opportunity',
      opportunity_title: 'Photovoltaik-Anlage Teil 1 (Leadgenerierung)',
      opportunity_number: 'OP-100',
      delivery_address: {
        $relation_ref: [
          {
            _tags: [],
            path: 'address',
            _id: 'FQMknAReKWEmcTpj3Sr1V',
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
          }
        ]
      },
      customer: {
        $relation: [
          {
            entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            _tags: ['customer']
          }
        ]
      },
      workflow: [
        {
          version: 2,
          lastUpdateTime: '2025-05-07T11:56:51.445Z',
          trigger: 'AUTOMATIC',
          assignedTo: [],
          creationTime: '2025-04-07T07:20:04.826Z',
          status: 'STARTED',
          wfExecId: '7il6fm2842x',
          updateEntityAttributes: [],
          selectedClosingReasons: [],
          enableECPWorkflow: true,
          name: 'Photovoltaik-Anlage B2C',
          nextOpenStep: {
            entityRefId: '86rv55zhdk3',
            id: '86rv55zhdk3'
          },
          taxonomies: [],
          flow: [
            {
              completedTime: '2025-05-07T11:56:51.439Z',
              name: 'Prüfungsphase',
              id: 'skimkuvala1',
              type: 'SECTION',
              steps: [
                {
                  requirements: [],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  completedTime: '2025-05-07T11:56:51.439Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'skimkuvala1',
                  type: 'STEP',
                  entityRefId: '0f3t0a9hvs8',
                  assignedTo: ['101408'],
                  lastUpdated: '2025-05-07T11:56:51.439Z',
                  ecp: {
                    description:
                      'Wir haben Ihre Anfrage erhalten und prüfen sie gerade.',
                    enabled: true,
                    label: 'Prüfungsphase'
                  },
                  userIds: [],
                  name: 'Prüfung der Daten auf Richtigkeit und Plausibilität',
                  id: '0f3t0a9hvs8',
                  definitionId: 'zzBis4GA',
                  status: 'COMPLETED',
                  manuallyCreated: false,
                  enabled: true
                }
              ],
              assignedTo: [],
              definitionId: '7tPWZ0un',
              status: 'COMPLETED',
              enabled: true
            },
            {
              name: 'Qualifizierungsphase / Vor-Ort-Termin',
              id: '7k6wxtztrq9',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    }
                  ],
                  startedTime: '2025-05-07T11:56:51.439Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: '7k6wxtztrq9',
                  type: 'STEP',
                  entityRefId: '86rv55zhdk3',
                  automationConfig: {
                    flowId: 'ae123b8e-7032-49aa-9785-67fd1785a56b'
                  },
                  assignedTo: [],
                  enabled: true,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  userIds: [],
                  name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung nicht erfolgreich - Automatisierung ausführen, um Interessent:in zwecks Rückruf zu kontaktieren. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
                  id: '86rv55zhdk3',
                  definitionId: 'yN5f0rIA',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Nach dem dritten Kontaktversuch: Frist auf +30 Tage setzen. Wenn innerhalb dieser Frist keine Rückmeldung durch Interessent:in Automatisierung ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn innerhalb der Frist eine Kontaktaufnahme erfolgt ist, Schritt überspringen.',
                    enabled: true
                  },
                  sectionId: '7k6wxtztrq9',
                  type: 'STEP',
                  entityRefId: 'l0qfzxahdqk',
                  automationConfig: {
                    flowId: '497dbc84-9c70-42e6-8aba-e85103ca9ba2'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  dynamicDueDate: {
                    stepId: 'yN5f0rIA',
                    timePeriod: 'days',
                    numberOfUnits: 1,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Weitere Kontaktaufnahme. Falls Interessent:in wieder nicht erreicht, Aufgabe offen lassen, Frist auf +1 Tag setzen und Automatisierung aus vorherigem Schritt erneut ausführen. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
                  id: 'l0qfzxahdqk',
                  definitionId: 'EeCC5puB',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                    enabled: true
                  },
                  sectionId: '7k6wxtztrq9',
                  type: 'STEP',
                  entityRefId: '2g6uebt8qan',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  userIds: [],
                  name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung - Datum in Feld "1. Vor-Ort-Termin" eintragen.',
                  id: '2g6uebt8qan',
                  definitionId: '_Y9T46UT',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  journey: {
                    journeyId: '077da6b0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Photovoltaik-Anlage Teil 2 (Nachqualifizierung Vor-Ort-Termin)',
                    id: '5d915b93-5487-467d-83ce-a9d89dde5b4d'
                  },
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die zusätzlichen Informationen und Fotos aus dem Vor-Ort-Termin der Opportunity hinzufügen können. Klicken Sie dafür auf "Photovoltaik-Anlage Teil 2 (Nachqualifizierung Vor-Ort-Termin)".',
                    enabled: true
                  },
                  sectionId: '7k6wxtztrq9',
                  type: 'STEP',
                  entityRefId: 'owbvqsblhm2',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  ecp: {
                    description:
                      'Für die weitere Planung ist es notwendig das Objekt vor Ort zu besichtigen.',
                    enabled: true,
                    label: 'Vor-Ort-Terminierung'
                  },
                  userIds: [],
                  name: 'Während des Vor-Ort-Termins: Zusätzliche Informationen und Fotos einholen - Daten über verknüpfte Klickstrecke hochladen.',
                  id: 'owbvqsblhm2',
                  definitionId: 'xMh0jYAR',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  journey: {
                    journeyId: '0240b570-1126-11f0-8e95-4d06e2df98e6',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: 'f61cd947-c717-4aaa-a424-6f0a2e91e322'
                  },
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".\n                                \nUploadkategorien:\n- Gebäudegrundriss\n- Zählerschrank\n- Zähler mit Zählernummer\n- möglicher Standort Wechselrichter/ Batteriespeicher\n- Dach\n- mögliche Verschattungen\n- Sonstiges\n',
                    enabled: true
                  },
                  sectionId: '7k6wxtztrq9',
                  type: 'STEP',
                  entityRefId: 'i5qbpkhti1i',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Dokumente/ Fotos aus Vor-Ort-Termin über verknüpfte Klickstrecke hochladen.',
                  id: 'i5qbpkhti1i',
                  definitionId: 'ZmyKvhEM',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: '7k6wxtztrq9',
                  type: 'STEP',
                  entityRefId: 'wvie93r4z6y',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  userIds: [],
                  name: 'Opportunity und alle relevanten Entitäten über das Teilen Symbol (oben rechts) mit dem Partner teilen.',
                  id: 'wvie93r4z6y',
                  definitionId: 'RvhUavum',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'j7eJh3wY',
              status: 'IN_PROGRESS',
              enabled: true
            },
            {
              name: 'Prüfungsphase Partner',
              id: '0wgz78m617a',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                    enabled: true
                  },
                  sectionId: '0wgz78m617a',
                  type: 'STEP',
                  entityRefId: 'fqdz6e36lff',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  userIds: [],
                  name: 'Partner: optionale 2. Vor-Ort-Terminvereinbarung - Datum in Feld "2. Vor-Ort-Termin" eintragen. Falls nicht relevant, Schritt überspringen.',
                  id: 'fqdz6e36lff',
                  definitionId: 'c36_ZWe9',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  journey: {
                    journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Allgemein - Uploads Partner',
                    id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
                  },
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: '0wgz78m617a',
                  type: 'STEP',
                  entityRefId: 'viktpwsceuu',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Erstellung Angebot - Dokument über verknüpfte Klickstrecke hochladen.',
                  id: 'viktpwsceuu',
                  definitionId: '7v_W2vaH',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '-hj_-Fi3',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Angebotsphase',
              id: '3p9ui2plyqd',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: '3p9ui2plyqd',
                  type: 'STEP',
                  entityRefId: '789t88yeke8',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Handwerker-Angebot überprüfen und auf Basis des Angebots eine Bestellung unter Gruppe "Bestellungen und Angebote" anlegen und speichern.',
                  id: '789t88yeke8',
                  definitionId: 'p3Pgs00f',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Sobald das finale Angebot an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Feld zu übertragen.',
                    enabled: true
                  },
                  sectionId: '3p9ui2plyqd',
                  type: 'STEP',
                  entityRefId: 'eq78j1ug0bm',
                  automationConfig: {
                    flowId: '5de894b0-174e-49e4-9eb5-884cb032e17c'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  ecp: {
                    description:
                      'Wir planen aktuell Ihre individuelle Photovoltaik-Anlage.',
                    enabled: true,
                    label: 'Planung der Photovoltaik-Anlage'
                  },
                  userIds: [],
                  name: 'Email-Vorlage "PV - Finales Angebot inkl. Angebotsannahme" auswählen, erstelltes Angebot prüfen und E-Mail versenden.',
                  id: 'eq78j1ug0bm',
                  definitionId: 'OfHwI_qm',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: '3p9ui2plyqd',
                  type: 'STEP',
                  entityRefId: 'd60g0m93xns',
                  automationConfig: {
                    flowId: 'b5c07ff3-b5a4-4f13-90c0-ad9004e63fb1'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  dynamicDueDate: {
                    stepId: 'OfHwI_qm',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Angebotsannahme erfolgt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Wenn "Ja", Schritt überspringen.',
                  id: 'd60g0m93xns',
                  definitionId: '5h5bw2yO',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  sectionId: '3p9ui2plyqd',
                  type: 'STEP',
                  entityRefId: 'huhcr2em6eb',
                  automationConfig: {
                    flowId: '497dbc84-9c70-42e6-8aba-e85103ca9ba2'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  ecp: {
                    description:
                      'Sind Sie mit dem unterbreiteten Angebot zufrieden?',
                    enabled: true,
                    label: 'Angebotsphase'
                  },
                  dynamicDueDate: {
                    stepId: '5h5bw2yO',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Angebotsannahme erfolgt? Wenn "Nein", Automatisierungsschritt ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn "Ja", Schritt überspringen.',
                  id: 'huhcr2em6eb',
                  definitionId: 'HMTLIkea',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'nkelpCQ7',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Vorbereitung Bereitstellung',
              id: 'mwd65w1sszc',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  journey: {
                    journeyId: '0240b570-1126-11f0-8e95-4d06e2df98e6',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: 'f61cd947-c717-4aaa-a424-6f0a2e91e322'
                  },
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die 1. Anzahlungsrechnung übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                    enabled: true
                  },
                  sectionId: 'mwd65w1sszc',
                  type: 'STEP',
                  entityRefId: 'cvpeth4phx0',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  userIds: [],
                  name: 'ERP: 1. Anzahlungsrechnung erstellen: Rechnungsversand an Kund:in (1. Rechnung - Anzahlung) - Anzahlungsrechnung über verknüpfte Klickstrecke hochladen.',
                  id: 'cvpeth4phx0',
                  definitionId: 'dd7i4fmj',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'AUTOMATION',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Hinweis: Mit der Ausführung der Automatisierung wird das Datum der Beauftragung des Partners in das entsprechende Feld übertragen. Die Beauftragung des Partners ist in den weiteren informationen im nächsten Schritt vermerkt.',
                    enabled: true
                  },
                  sectionId: 'mwd65w1sszc',
                  type: 'STEP',
                  entityRefId: 'lrqnd0ntkm6',
                  automationConfig: {
                    flowId: 'f7635782-6eb9-424a-8a5b-2c73623adb27'
                  },
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  dynamicDueDate: {
                    stepId: 'dd7i4fmj',
                    timePeriod: 'days',
                    numberOfUnits: 7,
                    actionTypeCondition: 'STEP_CLOSED'
                  },
                  userIds: [],
                  name: 'Wiedervorlage: Zahlung eingegangen? Wenn "Ja", Automatisierungsschritt ausführen - Beauftragung des Partners über nachfolgende Aufgabe. Wenn "Nein", Kontaktaufnahme mit Kund:in und neue Frist auf T+7 setzen.',
                  id: 'lrqnd0ntkm6',
                  definitionId: 'G8Y9cTif',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '65Dt7ZS9',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Installation inkl. Fertigstellung Partner',
              id: 'zo2dw2kgd00',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'Finale Beauftragung für Installation der Photovoltaik-Anlage: \nKund:in hat das Angebot angenommen. Für die Antragstellung beim Netzbetreiber, sowie die weitere interne Organisation bitte die Widerrufsfrist beachten (siehe Feld Ende Widerrufsfrist)!\n',
                    enabled: true
                  },
                  sectionId: 'zo2dw2kgd00',
                  type: 'STEP',
                  entityRefId: 'bqa09757ro9',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  userIds: [],
                  name: 'Partner: Antragstellung beim Netzbetreiber',
                  id: 'bqa09757ro9',
                  definitionId: 'bTVIdKd5',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  sectionId: 'zo2dw2kgd00',
                  type: 'STEP',
                  entityRefId: 'blan8da0ewi',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  userIds: [],
                  name: 'Partner: Terminvereinbarung und Baubeginn (nach Widerrufsfrist) - Datum Baubeginn in Feld "Baubeginn" eintragen.',
                  id: 'blan8da0ewi',
                  definitionId: 'g3eVTm5t',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  journey: {
                    journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Allgemein - Uploads Partner',
                    id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
                  },
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Abnahmeprotokoll der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'zo2dw2kgd00',
                  type: 'STEP',
                  entityRefId: '7sh784raar7',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  userIds: [],
                  name: 'Partner: Baumaßnahmen wurden fertiggestellt und abgenommen - Datum der Fertigstellung in Feld "Fertigstellung" eintragen - Abnahmeprotokoll über verknüpfte Klickstrecke hochladen.',
                  id: '7sh784raar7',
                  definitionId: 'An4yz9pM',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  journey: {
                    journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Allgemein - Uploads Partner',
                    id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
                  },
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Dokumentation der Errichtung und der Inbetriebnahme der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'zo2dw2kgd00',
                  type: 'STEP',
                  entityRefId: '9jjxqb757di',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  ecp: {
                    enabled: true,
                    label: 'Installation inkl. Fertigstellung'
                  },
                  userIds: [],
                  name: 'Partner: Dokumentation der Errichtung und der Inbetriebnahme - Dokumente über verknüpfte Klickstrecke hochladen.',
                  id: '9jjxqb757di',
                  definitionId: 'oYLqfdHr',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                },
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'oYLqfdHr'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  journey: {
                    journeyId: '020421a0-1126-11f0-bc7b-f59f0d1cc396',
                    name: 'Allgemein - Uploads Partner',
                    id: '7f2f19c5-1ecb-4997-8e9e-42d4a8d5245e'
                  },
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                    enabled: true
                  },
                  sectionId: 'zo2dw2kgd00',
                  type: 'STEP',
                  entityRefId: 'k2stp7txgci',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  ecp: {
                    enabled: false
                  },
                  userIds: [],
                  name: 'Partner: Schlussrechnung erstellen - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
                  id: 'k2stp7txgci',
                  definitionId: 'PnKp6bGK',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: 'OgeUHFyc',
              status: 'OPEN',
              enabled: true
            },
            {
              name: 'Abschluss',
              id: 'gjbhikukf23',
              type: 'SECTION',
              steps: [
                {
                  requirements: [
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'zzBis4GA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'yN5f0rIA'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'EeCC5puB'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '_Y9T46UT'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'xMh0jYAR'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'ZmyKvhEM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'RvhUavum'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'c36_ZWe9'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '7v_W2vaH'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'p3Pgs00f'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'OfHwI_qm'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: '5h5bw2yO'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'HMTLIkea'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'dd7i4fmj'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'G8Y9cTif'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'bTVIdKd5'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'g3eVTm5t'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'An4yz9pM'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'oYLqfdHr'
                    },
                    {
                      type: 'STEP',
                      condition: 'CLOSED',
                      definitionId: 'PnKp6bGK'
                    }
                  ],
                  startedTime: '2025-04-07T07:20:04.826Z',
                  journey: {
                    journeyId: '0240b570-1126-11f0-8e95-4d06e2df98e6',
                    name: 'Allgemein - Uploads Vertrieb',
                    id: 'f61cd947-c717-4aaa-a424-6f0a2e91e322'
                  },
                  created: '2025-04-07T07:20:04.826Z',
                  executionType: 'MANUAL',
                  assignedToInProgress: '-',
                  description: {
                    value:
                      'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                    enabled: true
                  },
                  sectionId: 'gjbhikukf23',
                  type: 'STEP',
                  entityRefId: 'bat3ao1pgkn',
                  assignedTo: [],
                  enabled: false,
                  lastUpdated: '2025-04-07T07:20:04.826Z',
                  ecp: {
                    enabled: true,
                    label: 'Abschluss'
                  },
                  userIds: [],
                  name: 'ERP: Schlussrechnung an Kund:in senden - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
                  id: 'bat3ao1pgkn',
                  definitionId: '76QWWDEa',
                  status: 'UNASSIGNED',
                  manuallyCreated: false
                }
              ],
              assignedTo: [],
              definitionId: '8vvcDG0J',
              status: 'OPEN',
              enabled: true
            }
          ],
          configuredClosingReasonSnapshot: [
            {
              title: 'Dach zu alt',
              id: 'aR7zJFjtI6Q0ZH_EXGtXc'
            },
            {
              title: 'Wirtschaftlichkeit',
              id: '4vDdM4Ta5TIiK2ZLQFv2M'
            },
            {
              title: 'Entscheidung für Mitbewerber',
              id: 'uUW4-bIsq5Ozm3xcmIRC8'
            },
            {
              title: 'Zeitlich nicht passend',
              id: 'ZdbD_S25HvYBZfOSX4Z1e'
            },
            {
              title: 'Keine Angabe von Gründen',
              id: 'nH_sgr1zfOtV13maXhScO'
            },
            {
              title: 'Keine Rückmeldung vom Kunden',
              id: '08xZ-Ex6VxT6fD_tZO-5E'
            },
            {
              title: 'Kosten zu hoch',
              id: 'eq8g6NXYOmqkWdh2EvieE'
            },
            {
              title: 'Zu lange Wartezeit',
              id: 'lm9Rp2kd8i94PfJpnQi7-'
            }
          ],
          contexts: [
            {
              schema: 'contact',
              title: 'Max Spark',
              id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
            },
            {
              schema: 'opportunity',
              title: 'OP-100 - Photovoltaik-Anlage Teil 1 (Leadgenerierung)',
              id: '5623d4b1-62d1-43ce-8118-44fc453c511c'
            }
          ],
          orgId: '16246022',
          definitionId: 'wfMXhDSGaI',
          id: '7il6fm2842x'
        }
      ]
    }
  ],
  hits: 9
}
